import React, { useEffect, useState } from "react";

function CardNuevoTorneo({ handleShow }) {
  const [img, setImagen] = useState(null);

  const clickNuevoTorneo = () => {
    handleShow();
  };

  // useEffect(() => {
  //   const randomNumber = Math.floor(Math.random() * 1000) + 1;
  //   setImagen(`https://picsum.photos/300/200?random=${randomNumber}`);
  // }, []);

  return (
    <div
      className="card"
      style={{ width: "18rem", cursor: "pointer", margin: "10px" }}
      onClick={clickNuevoTorneo}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
        }}
      >
        <h1 style={{ fontSize: "40px", margin: "0", lineHeight: "1" }}>+</h1>
        <p style={{ marginTop: "10px", textAlign: "center", lineHeight: "1" }}>
          Crear nuevo torneo
        </p>
      </div>
    </div>
  );
}

export default CardNuevoTorneo;
